import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { useIsAnyDynamicRateOnBookingLocked_Booking$key } from "./__generated__/useIsAnyDynamicRateOnBookingLocked_Booking.graphql";

export const useIsAnyDynamicRateOnBookingLocked = (
  bookingRef: useIsAnyDynamicRateOnBookingLocked_Booking$key | null
) => {
  const data = useFragment(
    useIsAnyDynamicRateOnBookingLockedFragmentString,
    bookingRef
  );
  const isDynamicLocked =
    data?.status === "CONFIRMED" &&
    data?.rounds?.edges?.some(
      (edge) => edge?.node?.roundRate?.rate?.dynamicOverridden
    );
  return isDynamicLocked;
};

const useIsAnyDynamicRateOnBookingLockedFragmentString = graphql`
  fragment useIsAnyDynamicRateOnBookingLocked_Booking on Booking {
    ... on StandardBooking {
      status
      rounds {
        edges {
          node {
            roundRate {
              rate {
                ... on CustomerRate {
                  dynamicOverridden
                }
              }
            }
          }
        }
      }
    }
  }
`;
